<template>
    <div   style="position:relative">
        <!--<div style="position:absolute;width: 100%">-->
            <!--<v-background></v-background>-->
        <!--</div>-->

        <div class="animated zoomIn" >
            <div class="Header" style="position:absolute;margin:10px auto;">
                <div style="width: 1205px;margin: 0 auto">
                <!--<div class="Header-box">-->
                    <v-header></v-header>
                </div>

                <div class="animated zoomIn" style="width: 1000px;margin: 0 auto">
                    <router-view />
                </div>

                <div class="animated zoomIn">
                    <div class="Header" >
                        <div class="Header-box">
                            <v-bottom></v-bottom>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div id="show">
            <v-goTop></v-goTop>
        </div>
        <div >
            <v-contact></v-contact>
        </div>

    </div>

</template>

<script>
    import GoTop from "../../components/GoTop";
    import Background from "../front/Background";
    import FrontHeader from "../../components/FrontHeader";
    import Bottom from "../../components/Bottom";
    import Contact from "../../components/Contact";
    export default {
        name: "Front",
        data() {
            return {
                user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
                show2: true
            }
        },
        components:{
            'v-goTop': GoTop,
            'v-background': Background,
            'v-header': FrontHeader,
            'v-bottom': Bottom,
            'v-contact': Contact,
        },

        methods: {
            logout() {
                this.$store.commit("logout");
                this.$message.success("退出成功")
            },
        }
    }
</script>

<style>
    @import "../../assets/css/typo.css";
    .Header {
        width: 100vw;
        /*height: 100vh;*/
    }
    .Header-box {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        /*width: 99vw;*/
        /*!*height: 100vh;*!*/
        display: flex;
        /*!*align-items: center;*!*/
        justify-content: center;
    }
</style>